import './App.css';

import Navbar from './components/Navbar';
import FloatingSidebar from './components/FloatingSidebar';
import Footer from './components/Footer';
import HeaderNew from './components/HeaderNew';
import Header from './components/Header';
import Master from './components/Master';
import Trailer from './components/Trailer';
import StudyMethod from './components/StudyMethod';
import Memberships from './components/Memberships';
import Financing from './components/Financing';
import Counseling from './components/Counseling';
import FeaturedResults from './components/FeaturedResults';
import FAQ from './components/FAQ';
import HeaderForm from './components/HeaderForm';

function App() {
	return (
		<main className='App'>
			<Navbar />
			{/* <FloatingSidebar /> */}
			<HeaderNew />
			{/* <Header /> */}
			<HeaderForm />
			<Master />
			<Trailer />
			{/* <StudyMethod /> */}
			<Memberships />
			<Financing />
			<Counseling />
			<FeaturedResults />
			<FAQ />
			<Footer />
		</main>
	);
}

export default App;
